import Cookies from "js-cookie";
import React, { createContext, PropsWithChildren, useContext, useState } from "react";
import { User } from "../models/User";

interface AuthContextInterface {
  token?: string | null;
  loggedUser?: User | null;
  refreshToken?: string | null;
  setLoggedUser?: React.Dispatch<React.SetStateAction<User | null>>;
  setToken?: React.Dispatch<React.SetStateAction<string | null>>;
  setRefreshToken?: React.Dispatch<React.SetStateAction<string | null>>;
}

const AuthContext = createContext<AuthContextInterface>({});

export const AuthProvider = ({ children }: PropsWithChildren) => {
  const tokenCookie = Cookies.get(window.__env.TOKEN_NAME)!;
  const refreshTokenCookie = Cookies.get(window.__env.REF_TOKEN_NAME)!;
  const [loggedUser, setLoggedUser] = useState<User | null>(null);
  const [token, setToken] = useState<string | null>(tokenCookie);
  const [refreshToken, setRefreshToken] = useState<string | null>(refreshTokenCookie);

  return (
    <AuthContext.Provider value={{ loggedUser, token, refreshToken, setLoggedUser, setToken, setRefreshToken }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext);
